// extracted by mini-css-extract-plugin
module.exports = {"box":"box--3jm-C","newsTab":"newsTab--3sVIt","active":"active--tM9eN"};